import { parsePhoneNumberFromString } from 'libphonenumber-js'

export const getOtpChannelHint = (phoneNumber: string, method: string) => {
  if (parsePhoneNumberFromString(phoneNumber)?.country !== 'IN') return undefined
  return method === 'voice' ? 'voice call' : 'SMS'
}
